var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Icon, Stack, StackChildren, Text } from '@doordash/design-language';
import { CreateBudgetPlaceOrderStrings } from './PlaceOrderStrings';
import { TextField } from '@doordash/component-fields';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
var strings = CreateBudgetPlaceOrderStrings;
var InputFieldContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 480px;\n"], ["\n  max-width: 480px;\n"])));
export var BudgetForm = function (_a) {
    var errorMessage = _a.errorMessage, handleFormSubmit = _a.handleFormSubmit;
    var initialFormValues = {
        budgetName: '',
        budgetAmount: null,
    };
    var validationSchema = yup.object().shape({
        budgetName: yup.string().required(strings.errors.budgetNameIsRequired()),
        budgetAmount: yup
            .number()
            .positive()
            .typeError(strings.errors.budgetAmountShouldBeNumber())
            .required(strings.errors.budgetAmountIsRequired()),
    });
    return (React.createElement(Formik, { initialValues: initialFormValues, validationSchema: validationSchema, validateOnChange: false, validateOnBlur: false, onSubmit: handleFormSubmit }, function (_a) {
        var errors = _a.errors, isSubmitting = _a.isSubmitting, values = _a.values, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit;
        return (React.createElement(Form, { noValidate: true },
            React.createElement(Stack, { size: Stack.Sizes.XLarge },
                React.createElement(StackChildren, null,
                    React.createElement(InputFieldContainer, null,
                        React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.labels.budgetName(), error: errors.budgetName, placeholder: strings.placeholders.budgetName(), onChange: handleChange('budgetName'), isRequired: true, value: values.budgetName, "data-anchor-id": "budgetName", maxLength: 255 })),
                    React.createElement(InputFieldContainer, null,
                        React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.labels.budgetAmount(), error: errors.budgetAmount, placeholder: "100.00", onChange: handleChange('budgetAmount'), isRequired: true, value: values.budgetAmount ? values.budgetAmount : '', "data-anchor-id": "budgetAmount", maxLength: 255 })))),
            React.createElement(StackChildren, null,
                React.createElement("div", null,
                    React.createElement(Button, { onClick: handleSubmit, children: strings.cta.text(), trailingIcon: Icon.Types.ArrowUpRight, state: isSubmitting ? Button.States.Loading : Button.States.Default, isInline: true }),
                    React.createElement(Text, { children: strings.cta.captionText(), styles: Text.Styles.Caption1, color: Text.Colors.TextTertiary }),
                    !!errorMessage && (React.createElement(React.Fragment, null,
                        React.createElement(Stack, { size: Stack.Sizes.Medium }),
                        React.createElement(Text, { children: errorMessage, styles: Text.Styles.Body1, color: Text.Colors.TextError })))))));
    }));
};
var templateObject_1;
